import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { BlazeEffects } from './blaze.effects';
import { FeatureFlagsEffects } from './feature-flags.effects';

/**
 * The bootstrap effects that hydrate the app: `BlazeEffects` restores the session from local
 * storage, `FeatureFlagsEffects` fetches the account's flags.
 *
 * why in the app shell: they reach across `app-state`, `auth`, `theming` and `platform`, and a
 * library owning that composition would close a cycle between those four.
 *
 * why a module rather than a provider function: the order matters — `BlazeEffects` must be
 * registered last so the state it hydrates is already in the store, and `EffectsModule.forFeature`
 * is what guarantees that within one registration.
 */
@NgModule({
  imports: [EffectsModule.forFeature([FeatureFlagsEffects, BlazeEffects])],
})
export class BlazeEffectsModule {}
